import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const blobToken = async (uri: string) => {
  return await apiInputService.post("/documentFile/generateToken/", {
    uri: uri,
  });
};

export const useBlobToken = (options?: any) => {
  return useMutation(blobToken, {
    ...options,
  });
};
